// extracted by mini-css-extract-plugin
export default {"img":"logoSettings_img__nUiXU"};